/* colors.js */
export const ISO_COLORS = [
  "#bb86fc", 
  "#03dac6", 
  "#cf6679",
  "#3700b3", 
  "#018786", 
  "#ff0266"
];